export const LENDING_LIMIT_LOAN_SUMMARY_MODAL = 'LENDING_LIMIT_LOAN_SUMMARY_MODAL';

export const setLendingLoanLimitSummaryModal = (state) => (dispatch) => {
    dispatch({ type: LENDING_LIMIT_LOAN_SUMMARY_MODAL, state });
};

export default {
    LENDING_LIMIT_LOAN_SUMMARY_MODAL,
    setLendingLoanLimitSummaryModal,
};
